// javascript
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getTramitePorId, modificarTramite, cancelarTramite, reactivarTramite, getTramites } from "../services/tramiteService";
import { getTipoTramites } from "../services/tipoTramiteService";
import EventoService from '../services/eventoService';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import CancelIcon from "@mui/icons-material/Cancel";
import CrearEventoModal from './CrearEventoModal';
import ChecklistTramite from './Tramite/ChecklistTramite';
import TarjetaCobroTramite from './Cobranzas/TarjetaCobroTramite';
import SeccionCobranzaTramite from './Cobranzas/SeccionCobranzaTramite';
import ExpedientesAnsesTramite, { enSeguimientoDeExpediente } from './ExpedientesAnsesTramite';
import useCustomModal from "../hooks/useCustomModal";
import useVolverAtras from "../hooks/useVolverAtras";
import PanelUbicacionTramite from "./PanelUbicacionTramite";
import CustomModal from "./CustomModal";
import HistorialTramite from "./HistorialTramite";
import PanelAccionesAvanzadasTramite from './Administracion/PanelAccionesAvanzadasTramite';
import GestorEstadoTramite from "../gestores/GestorEstadoTramite";
import CargaArchivos from "../gestores/GestorCargaDeArchivos";
import RegularidadAporte from "./RegularidadAporte";
import ModalGastosPorTramite from './GastosMedicosComponentes/ModalGastosPorTramite';
import WhatsAppChatModal from "./WhatsAppChatModal";
import WhatsAppHeaderButton from './WhatsAppHeaderButton';
import NotaComentario from './NotaComentario';
import BotonGenerarCaratula from './Caratula/BotonGenerarCaratula';
import { useAuth } from '../auth/AuthContext';
import { normalizeTelefonoForStorage } from '../utils/telefonoCordoba';

// --- [NUEVOS IMPORTS] ---
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import NotificacionService from "../services/notificacionService";
import { apellidoNombre } from '../utils/nombrePersona';
import EtiquetaTramite from './EtiquetaTramite';
import ChipAmparoIniciado from './Amparo/ChipAmparoIniciado';

function DetalleTramite() {
    const { idTramite } = useParams();
    const { user } = useAuth();
    const [tramite, setTramite] = useState(null);
    const [loading, setLoading] = useState(true);
    // Se bumpea después de generar+adjuntar la Carátula para forzar el remount (y re-fetch)
    // de CargaArchivos, que no expone otra forma de refrescarse desde el padre.
    const [archivosVersion, setArchivosVersion] = useState(0);
    const navigate = useNavigate();
    // Este componente sirve a RTI y al ART legacy, así que el fallback depende del tipo.
    const volverAtras = useVolverAtras(tramite?.idTipoTramite === 2 ? '/art/tramites' : '/rti/tramites');
    const [editMode, setEditMode] = useState(false);
    const [tramiteEdit, setTramiteEdit] = useState(null);
    const [tiposTramite, setTiposTramite] = useState([]);
    const [mostrarDialogoCancelar, setMostrarDialogoCancelar] = useState(false);
    const [motivoCancelacion, setMotivoCancelacion] = useState('');
    const [observacionesCancelacion, setObservacionesCancelacion] = useState('');
    const [mostrarDialogoReactivar, setMostrarDialogoReactivar] = useState(false);
    const [observacionesReactivacion, setObservacionesReactivacion] = useState('');
    const [eventos, setEventos] = useState([]);
    const [cargandoEventos, setCargandoEventos] = useState(true);
    const [mostrarModalEvento, setMostrarModalEvento] = useState(false);
    const [fechaSeleccionadaEvento, setFechaSeleccionadaEvento] = useState(new Date());
    const { modalState, hideModal, showModal, showAlert, showSuccess, showError, showWarning, showConfirm } = useCustomModal();
    const [modalHistorialAbierto, setModalHistorialAbierto] = useState(false);
    const [modalGastosOpen, setModalGastosOpen] = useState(false);
    // { phone, name } del contacto activo en el chat; null = cerrado
    const [whatsAppTarget, setWhatsAppTarget] = useState(null);
    const [tramitesARTCliente, setTramitesARTCliente] = useState([]);

    // Función para recargar solo los eventos
    const recargarEventos = async () => {
        try {
            const response = await EventoService.getEventosPorTramite(idTramite);
            setEventos(response.data);
        } catch (error) {
            console.error("Error recargando eventos:", error);
        }
    };

    // Función para recargar el trámite cuando cambia el estado
    const recargarTramite = async () => {
        try {
            const dataTramite = await getTramitePorId(idTramite);
            setTramite(dataTramite);
        } catch (error) {
            console.error("Error recargando trámite:", error);
        }
    };

    useEffect(() => {
        const cargarDatos = async () => {
            try {
                setLoading(true);
                setCargandoEventos(true);

                const [tramiteResult, eventosResult] = await Promise.allSettled([
                    getTramitePorId(idTramite),
                    EventoService.getEventosPorTramite(idTramite),
                ]);

                const dataTramite = tramiteResult.status === 'fulfilled' ? tramiteResult.value : null;
                setTramite(dataTramite);
                setEventos(eventosResult.status === 'fulfilled' ? eventosResult.value.data : []);

                if (dataTramite?.cliente?.cuil) {
                    try {
                        const ID_TIPO_ART = 2;
                        const artPayload = await getTramites(0, 50, dataTramite.cliente.cuil, ID_TIPO_ART, null, '');
                        const artItems = Array.isArray(artPayload) ? artPayload : (artPayload?.content || []);
                        setTramitesARTCliente(artItems);
                    } catch (error) {
                        console.error("Error cargando trámites ART del cliente:", error);
                        setTramitesARTCliente([]);
                    }
                }
            } catch (error) {
                console.error("Error al cargar trámite:", error);
            } finally {
                setLoading(false);
                setCargandoEventos(false);
            }
        };
        cargarDatos();
    }, [idTramite]);

    // Auto-refresco de eventos cada 30 segundos y listener para eventos personalizados
    useEffect(() => {
        // Listener para eventos creados desde gestores
        const handleEventoCreado = () => {
            console.log('📅 VistaDetalladaTramite: Evento detectado, recargando eventos...');
            recargarEventos();
        };

        window.addEventListener('eventoCreadoDesdeChat', handleEventoCreado);

        // Polling cada 30 segundos para mantener actualizada la lista
        const interval = setInterval(() => {
            recargarEventos();
        }, 30000);

        return () => {
            window.removeEventListener('eventoCreadoDesdeChat', handleEventoCreado);
            clearInterval(interval);
        };
    }, [idTramite]);

    const handleModificar = () => {
        setTramiteEdit({ ...tramite });
        setEditMode(true);
    };

    const handleAbrirHistorial = () => {
        setModalHistorialAbierto(true);
    };

    const handleCerrarModal = () => {
        setModalHistorialAbierto(false);
    };

    const handleAbrirGastos = () => {
        setModalGastosOpen(true);
    };

    const handleCerrarGastos = () => {
        setModalGastosOpen(false);
    };

    const handleGuardar = async () => {
        try {
            // Construimos el objeto a enviar
            const tramiteParaGuardar = {
                idTipoTramite: Number(tramiteEdit.idTipoTramite),
                comentarios: tramiteEdit.comentarios || "",
                patologia: tramiteEdit.patologia || "",
                organismo: tramiteEdit.organismo || null,
                version: tramite.version
            };

            console.log("📤 Enviando al backend:", tramiteParaGuardar);

            const tramiteActualizado = await modificarTramite(tramiteEdit.idTramite, tramiteParaGuardar);

            // Actualizamos el estado con la respuesta del backend (que trae la nueva versión)
            setTramite(tramiteActualizado);
            setEditMode(false);
            setTramiteEdit(null);

            toast.success("Trámite modificado correctamente");

        } catch (error) {
            console.error("❌ Error:", error.response?.data);

            // --- MANEJO DE CONCURRENCIA (ERROR 409) ---
            if (error.response && error.response.status === 409) {
                showModal({
                    title: "⚠️ Conflicto de Edición",
                    body: (
                        <div className="alert alert-warning">
                            <p><strong>¡Atención!</strong></p>
                            <p>Otro usuario ha modificado este trámite mientras usted lo estaba editando.</p>
                            <p>Para evitar sobrescribir datos importantes, es necesario recargar la información más reciente.</p>
                            <hr/>
                            <p className="mb-0 text-muted" style={{fontSize: '0.9em'}}>
                                <em>Sus cambios actuales no se guardarán.</em>
                            </p>
                        </div>
                    ),
                    footer: (
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                hideModal();      // Cerrar modal
                                setEditMode(false); // Salir de edición
                                recargarTramite();  // Recargar datos del servidor
                            }}
                        >
                            Entendido, recargar datos
                        </button>
                    )
                });
            } else {
                // Manejo de errores normal
                toast.error(`Error al guardar: ${error.response?.data?.message || error.message}`);
            }
        }
    };

    // Guardar comentario desde la nota sticky (sin necesidad de entrar en modo edición)
    const handleGuardarComentario = async (nuevoComentario) => {
        try {
            const tramiteParaGuardar = {
                idTipoTramite: Number(tramite.tipoTramite?.idTipoTramite || tramite.idTipoTramite),
                comentarios: nuevoComentario,
                patologia: tramite.patologia || "",
                organismo: tramite.organismo || null,
                version: tramite.version
            };
            await modificarTramite(tramite.idTramite, tramiteParaGuardar);
            // Recargamos el trámite completo del backend para tener version y datos frescos
            await recargarTramite();
            toast.success("Comentario actualizado correctamente");
        } catch (error) {
            console.error("Error al guardar comentario:", error);
            if (error.response && error.response.status === 409) {
                showModal({
                    title: "⚠️ Conflicto de Edición",
                    body: (
                        <div className="alert alert-warning">
                            <p><strong>¡Atención!</strong></p>
                            <p>Otro usuario ha modificado este trámite. Recargue la información.</p>
                        </div>
                    ),
                    footer: (
                        <button className="btn btn-primary" onClick={() => { hideModal(); recargarTramite(); }}>
                            Entendido, recargar datos
                        </button>
                    )
                });
            } else {
                toast.error(`Error al guardar comentario: ${error.response?.data?.message || error.message}`);
            }
            throw error;
        }
    };

    const handleGuardarEvento = async (evento) => {
        try {
            const responseEvento = await EventoService.crearEvento({
                ...evento,
                idTramite: idTramite
            });

            const idEventoCreado = responseEvento.data.idEvento || responseEvento.data;

            // 2. Programar notificaciones si hay tiempos seleccionados
            if (evento.tiemposRecordatorio && evento.tiemposRecordatorio.length > 0) {
                await NotificacionService.programarNotificacionesAutomaticas(
                    idEventoCreado,
                    evento.tiemposRecordatorio
                );
            }

            // Disparar evento personalizado para actualizar el calendario
            console.log('📅 VistaDetalladaTramite: Evento creado - disparando actualización del calendario...');
            window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', {
                detail: { timestamp: Date.now(), source: 'tramite' }
            }));

            // Recargar eventos
            const response = await EventoService.getEventosPorTramite(idTramite);
            setEventos(response.data);

            setMostrarModalEvento(false);
            toast.success("Evento creado correctamente");
        } catch (error) {
            console.error("Error al crear evento:", error);
            toast.error("Error al crear el evento");
        }
    };

    const formatearFechaEvento = (fechaString) => {
        if (!fechaString) return 'Fecha no disponible';
        const partes = fechaString.split('-');
        const fechaUTC = new Date(Date.UTC(partes[0], partes[1] - 1, partes[2]));
        return fechaUTC.toLocaleDateString('es-ES', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC'
        });
    };

    useEffect(() => {
        const cargarTipos = async () => {
            const tipos = await getTipoTramites();
            setTiposTramite(tipos);
        };
        cargarTipos();
    }, []);

    const handleCancelar = () => {
        setEditMode(false);
        setTramiteEdit(null);
    };

    const handleCancelarTramite = async () => {
        try {
            await cancelarTramite(tramite.idTramite, motivoCancelacion, observacionesCancelacion);
            setMostrarDialogoCancelar(false);
            setMotivoCancelacion('');
            setObservacionesCancelacion('');

            // Recargar el trámite para mostrar el estado actualizado
            const tramiteActualizado = await getTramitePorId(idTramite);
            setTramite(tramiteActualizado);

            toast.success("Trámite cancelado correctamente");
        } catch (error) {
            console.error("❌ Error al cancelar trámite:", error);
            let mensaje = 'Error al cancelar el trámite';

            if (error.response) {
                mensaje = error.response.data || `Error ${error.response.status}: ${error.response.statusText}`;
            } else if (error.request) {
                mensaje = 'Error de conexión con el servidor';
            } else {
                mensaje = error.message || 'Error desconocido';
            }

            showError(mensaje, 'Error al Cancelar');
        }
    };

    const puedeCancelar = () => {
        if (!tramite) return false;
        // No se puede cancelar si ya está Completo (8) o Cancelado (14)
        return tramite.idEstadoActual !== 8 && tramite.idEstadoActual !== 14;
    };

    const handleReactivarTramite = async () => {
        try {
            await reactivarTramite(tramite.idTramite, observacionesReactivacion);
            setMostrarDialogoReactivar(false);
            setObservacionesReactivacion('');

            // Recargar el trámite para mostrar el estado actualizado
            const tramiteActualizado = await getTramitePorId(idTramite);
            setTramite(tramiteActualizado);

            toast.success("Trámite reactivado correctamente");
        } catch (error) {
            console.error("❌ Error al reactivar trámite:", error);
            let mensaje = 'Error al reactivar el trámite';

            if (error.response) {
                mensaje = error.response.data || `Error ${error.response.status}: ${error.response.statusText}`;
            } else if (error.request) {
                mensaje = 'Error de conexión con el servidor';
            } else {
                mensaje = error.message || 'Error desconocido';
            }

            showError(mensaje, 'Error al Reactivar');
        }
    };

    const puedeReactivar = () => {
        if (!tramite) return false;
        return tramite.idEstadoActual === 14; // Solo se puede reactivar si está Cancelado
    };

    // Función para obtener la ruta de estados relevante para este trámite
    const obtenerRutaEstados = () => {
        if (!tramite) return [];

        // Estados base que todos los trámites atraviesan
        const estadosBase = [
            "Ingreso del Trámite",      // 1
            "Turno médico asignado",    // 2
            "Espera de documentación",  // 3
            "Aprobación médica",        // 4
            "Turno Anses",              // 5
            "Turno Junta Médica",       // 6
            "Espera de 1° Dictamen"     // 7
        ];

        // Determinar el estado final
        const estadoActual = tramite.idEstadoActual;
        const nombreEstadoActual = tramite.nombreEstadoActual;

        // Si está cancelado, mostrar solo base + cancelado
        if (estadoActual === 14) {
            return [...estadosBase, "Cancelado"];
        }

        // Si está completo (favorable), mostrar solo base + completo
        if (estadoActual === 8) {
            return [...estadosBase, "Completo"];
        }

        // Si está en proceso de apelación o ya llegó a estados judiciales
        // Camino de apelación: 7 → 9 → 15 → 10 → 11 → 16 → 17 → 18 → 19 → (8 o 13)
        const estadosApelacion = [];

        // Verificar si pasó por Primera Apelación (9)
        if (estadoActual >= 9 || nombreEstadoActual === "Primera Apelación") {
            estadosApelacion.push("Primera Apelación"); // 9
        }

        // Verificar si pasó por Espera Dictamen CMC (15)
        if (estadoActual === 15 || (estadoActual > 15 && estadoActual !== 8 && estadoActual !== 13 && estadoActual !== 14)) {
            estadosApelacion.push("Espera Dictamen CMC"); // 15
        }

        // Verificar si pasó por Segunda Apelación (10)
        if (estadoActual >= 10 && estadoActual !== 15 && estadoActual !== 8 && estadoActual !== 13 && estadoActual !== 14) {
            estadosApelacion.push("Segunda Apelación"); // 10
        }

        // Verificar si pasó por Instancia Judicial (11)
        if (estadoActual >= 11 && estadoActual !== 8 && estadoActual !== 13 && estadoActual !== 14) {
            estadosApelacion.push("Instancia Judicial"); // 11
        }

        // Verificar si pasó por Espera Fecha de Pericia (16)
        if (estadoActual >= 16 && estadoActual !== 8 && estadoActual !== 13 && estadoActual !== 14) {
            estadosApelacion.push("Espera Fecha de Pericia"); // 16
        }

        // Verificar si pasó por Pericia Médica Asignada (17)
        if (estadoActual >= 17 && estadoActual !== 8 && estadoActual !== 13 && estadoActual !== 14) {
            estadosApelacion.push("Pericia Médica Asignada"); // 17
        }

        // Verificar si pasó por Espera Dictamen Tribunal (18)
        if (estadoActual >= 18 && estadoActual !== 8 && estadoActual !== 13 && estadoActual !== 14) {
            estadosApelacion.push("Espera Dictamen Tribunal"); // 18
        }

        // Verificar si pasó por Sentencia Judicial (19)
        if (estadoActual >= 19 || nombreEstadoActual === "Sentencia Judicial") {
            estadosApelacion.push("Sentencia Judicial"); // 19
        }

        // Estado final
        if (estadoActual === 13) {
            estadosApelacion.push("Rechazado"); // 13 - Desfavorable
        } else if (estadoActual === 8 && estadosApelacion.length > 0) {
            estadosApelacion.push("Completo"); // 8 - Favorable (después de juicio)
        }

        return [...estadosBase, ...estadosApelacion];
    };

    const estadosOrden = obtenerRutaEstados();
    const estadosFallidosNombres = ["Rechazado", "Cancelado"];

    if (loading) {
        return (
            <div className="text-center my-5">
                <div
                    className="spinner-border text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                ></div>
                <p className="mt-3 fw-semibold">Cargando detalles del trámite...</p>
            </div>
        );
    }

    if (!tramite) {
        return (
            <div className="alert alert-danger mt-4">
                No se encontró el trámite.
            </div>
        );
    }

    const cliente = tramite.cliente || {};

    const verDetalleCliente = (cuil) => {
        navigate(`/clientes/vista-detallada/${cuil.toString()}`);
    };

    // ----> [START] NUEVA FUNCIÓN PARA BANNER DE ESTADO FINAL <----
    const renderEstadoFinalBanner = () => {
        if (!tramite) return null;

        let config = null;
        // El último comentario suele tener el motivo de cierre/cancelación/rechazo
        const ultimoComentario = tramite.ultimoComentario || "Sin observaciones adicionales.";

        switch (tramite.idEstadoActual) {
            case 8: // Completo
                // Detectar si es favorable o desfavorable según el comentario
                const esFavorable = ultimoComentario.toLowerCase().includes('favorable');
                const tipoResultado = esFavorable ? ' - FAVORABLE' : '';

                config = {
                    bg: 'success',
                    icon: <CheckCircleIcon style={{ fontSize: '2.5rem' }} />,
                    titulo: `Trámite Completo${tipoResultado}`
                };
                break;
            case 13: // Rechazado
                // Detectar si es desfavorable por sentencia judicial
                const esDesfavorable = ultimoComentario.toLowerCase().includes('desfavorable');
                const tipoRechazo = esDesfavorable ? ' - DESFAVORABLE' : '';

                config = {
                    bg: 'danger',
                    icon: <CancelIcon style={{ fontSize: '2.5rem' }} />,
                    titulo: `Trámite Rechazado${tipoRechazo}`
                };
                break;
            case 14: // Cancelado
                config = {
                    bg: 'warning',
                    icon: <WarningIcon style={{ fontSize: '2.5rem' }} />,
                    titulo: 'Trámite Cancelado'
                };
                break;
            default:
                return null; // No es un estado final, no renderizar banner.
        }

        return (
            <div className={`alert alert-${config.bg} border-0 rounded-4 shadow-lg p-4 mb-4 d-flex align-items-center`}>
                <span className={`me-3`}>{config.icon}</span>
                <div>
                    <h4 className="fw-bold mb-1">{config.titulo}</h4>
                    <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>
                        <strong>Detalle:</strong> {ultimoComentario}
                    </p>
                </div>
            </div>
        );
    };
    // ----> [END] NUEVA FUNCIÓN PARA BANNER DE ESTADO FINAL <----


    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-start mb-4">
                <div style={{ flex: '1 1 20rem', minWidth: 0 }}>
                    <div className="d-flex align-items-center flex-wrap gap-3 mb-1">
                        <h2 className="fw-bold text-primary mb-0">Detalles del Trámite</h2>
                        {tramite.tipoTramite && (
                            <span className="badge bg-primary bg-opacity-10 text-primary border border-primary-subtle rounded-pill fs-6 px-3">
                                {tramite.tipoTramite.nombre}
                            </span>
                        )}
                        <EtiquetaTramite etiqueta={tramite.etiqueta} />
                        {/* Si sobre este expediente se promovio un amparo por mora ante ANSES, avisa
                            y linkea a su ficha (V239). Es lo que el Excel anota a mano como
                            "AMPARO INICIADO" sobre la fila del tramite. */}
                        <ChipAmparoIniciado idTramite={tramite.idTramite} />
                    </div>
                    {cliente.apellido && cliente.nombre && (
                        <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                            <h5 className="text-secondary fw-semibold mb-0">
                                <PersonSearchIcon fontSize="small" className="me-1 mb-1" />
                                {apellidoNombre(cliente.apellido, cliente.nombre)}
                            </h5>
                            {cliente.telefonoPropio && (
                                <WhatsAppHeaderButton
                                    phone={cliente.telefonoPropio}
                                    clientName={`${cliente.nombre} ${cliente.apellido}`}
                                    onClick={() => window.dispatchEvent(
                                        new CustomEvent('openAdminSidebar', { detail: { tab: 'whatsapp' } })
                                    )}
                                />
                            )}
                        </div>
                    )}
                    {/* Ubicación física de la carpeta e inicio diferido. Es la misma vista que
                        usan RTI y ART (se elige por idTipoTramite), y era el único módulo que
                        no lo tenía: el panel ya existía y se usa en los otros nueve. */}
                    <PanelUbicacionTramite tramite={tramite} onUpdated={setTramite} />
                </div>
                <div className="d-flex gap-2 mt-1 align-items-center flex-wrap">
                    {tramite.idTipoTramite === 1 && (
                        <BotonGenerarCaratula
                            tipo="RTI"
                            idTramite={tramite.idTramite}
                            onGenerado={() => setArchivosVersion((v) => v + 1)}
                        />
                    )}
                    <button
                        className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill"
                        onClick={volverAtras}
                    >
                        <ArrowBackIcon fontSize="small" /> Volver
                    </button>
                </div>
            </div>

            {/* Trámite ART complementario */}
            {tramitesARTCliente.length > 0 ? (
                <div style={{ marginBottom: '1rem', padding: '0.75rem 1rem', borderRadius: '12px', border: '1px solid #fbcfe8', background: 'var(--danger-bg)', display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                    <i className="bi bi-heart-pulse-fill" style={{ color: '#db2777', fontSize: '1.1rem', marginTop: 2 }}></i>
                    <div>
                        <strong style={{ color: '#9d174d', fontSize: '0.88rem' }}>
                            Este cliente también tiene {tramitesARTCliente.length === 1 ? 'un trámite ART' : `${tramitesARTCliente.length} trámites ART`}
                        </strong>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.5rem' }}>
                            {tramitesARTCliente.map((t) => (
                                <button
                                    key={t.idTramite}
                                    className="badge"
                                    style={{ background: '#fce7f3', color: '#9d174d', fontWeight: 600, border: '1px solid #fbcfe8', borderRadius: '6px', padding: '0.3rem 0.6rem', cursor: 'pointer', fontSize: '0.8rem' }}
                                    onClick={() => navigate(`/art/tramites/${t.idTramite}`)}
                                >
                                    #{t.idTramite} — {t.nombreEstadoActual || t.estadoActual || 'Sin estado'}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="d-flex flex-wrap align-items-start gap-3" style={{ marginBottom: '1rem', padding: '0.75rem 1rem', borderRadius: '12px', border: '1px solid #d1d5db', background: '#f9fafb' }}>
                    <i className="bi bi-heart-pulse" style={{ color: '#9ca3af', fontSize: '1.1rem', marginTop: 2 }}></i>
                    <div className="flex-grow-1">
                        <strong style={{ color: '#374151', fontSize: '0.88rem' }}>Este cliente no tiene trámite ART</strong>
                        {tramite?.comentarios && (() => {
                            const match = tramite.comentarios.match(/(?:\[MOTIVO NO INICIO ART]\s*|Motivo por no iniciar ART:\s*|Motivo por el cual no se inicia tambi[eé]n ART:\s*)(.+?)(?:\n|$)/i);
                            return match ? (
                                <div style={{ fontSize: '0.82rem', color: '#6b7280', marginTop: '0.25rem' }}>
                                    Motivo registrado: {match[1]}
                                </div>
                            ) : null;
                        })()}
                        <div className="mt-3">
                            <button
                                className="btn btn-sm d-inline-flex align-items-center gap-2"
                                style={{ fontSize: '0.8rem', border: '1px solid #db2777', color: '#9d174d', borderRadius: '8px', padding: '0.25rem 0.75rem' }}
                                onClick={() => navigate(`/art/tramites/iniciar-tramite/${tramite?.cliente?.cuil}`)}
                            >
                                <i className="bi bi-plus-circle"></i>
                                Iniciar trámite ART
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ----> [START] BANNER DE ESTADO FINAL INVOCADO <---- */}
            {renderEstadoFinalBanner()}
            {/* ----> [END] BANNER DE ESTADO FINAL INVOCADO <---- */}

            {/* Expedientes de ANSES del RTI (V265): para Para aprobar y los avisos del seguimiento. */}
            {enSeguimientoDeExpediente(tramite.nombreEstadoActual) && <ExpedientesAnsesTramite idTramite={tramite.idTramite} />}


            {/* --- Nota Sticky de Comentarios --- */}
            {tramite && (
                <NotaComentario
                    valor={tramite.comentarios || ''}
                    onGuardar={handleGuardarComentario}
                    label="Comentarios del Trámite"
                    color="blue"
                    nombreUsuario={user?.nombre || ''}
                />
            )}

            {/* Cobranza del trámite: desplegable, debajo del estado y los comentarios */}
            <SeccionCobranzaTramite tramite={tramite} />

            {/* 🕓 Línea de tiempo de estados */}
            <div
                className="card shadow-sm border-0 rounded-4 p-4 mt-2 mb-3"
                style={{
                    backgroundColor: "#f8f9fa",
                    cursor: "pointer",
                    transition: "all 0.2s ease"
                }}
                onClick={handleAbrirHistorial}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e9ecef";
                    e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                    e.currentTarget.style.transform = "translateY(0)";
                }}
            >
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold text-secondary mb-0">Progreso del Trámite</h5>
                    <span className="text-primary">
                        <i className="bi bi-arrow-right-circle me-1"></i>
                        Ver detalles
                    </span>
                </div>

                <div className="d-flex justify-content-between align-items-center position-relative"
                     style={{ overflowX: "auto", padding: "10px 0" }}>

                    <div className="position-absolute start-0 border-top"
                         style={{ top: "35%", left: "-3%", width: "170%",borderTop: "3px solid #dee2e6", zIndex: 1 }}></div>

                    {estadosOrden.map((estado, index) => {
                        const indiceActual = estadosOrden.indexOf(tramite.nombreEstadoActual);
                        const completado = index < indiceActual;
                        const actual = index === indiceActual;
                        const fallido = actual && estadosFallidosNombres.includes(tramite.nombreEstadoActual);

                        let color = "#adb5bd"; // Gris (Pendiente)
                        if (completado) color = "#0d6efd"; // Azul (Completado)
                        if (actual) color = fallido ? "#dc3545" : "#198754"; // Rojo (Fallido) o Verde (Actual)

                        const borde = actual ? `4px solid ${color}` : `2px solid ${color}`;

                        return (
                            <div
                                key={estado}
                                className="d-flex flex-column align-items-center text-center"
                                style={{ position: "relative", zIndex: 2, minWidth: "160px" }}
                            >
                                <div
                                    className="rounded-circle mb-2"
                                    style={{
                                        width: "22px",
                                        height: "22px",
                                        backgroundColor: color,
                                        border: borde,
                                        transition: "all 0.3s ease"
                                    }}
                                ></div>
                                <span
                                    style={{
                                        fontSize: "0.85rem",
                                        color: actual ? color : (completado ? "#0d6efd" : "#6c757d"),
                                        fontWeight: actual ? "600" : "normal",
                                        whiteSpace: "nowrap"
                                    }}
                                >
                                    {estado}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Gestor dinámico de estados */}
            {/* --- [MODIFICACIÓN] No mostrar el gestor si el estado es final --- */}
            {!estadosFallidosNombres.includes(tramite.nombreEstadoActual) && tramite.idEstadoActual !== 8 && (
                <GestorEstadoTramite
                    tramite={tramite}
                    onEstadoCambiado={async () => {
                        const tramiteActualizado = await getTramitePorId(idTramite);
                        setTramite(tramiteActualizado);
                    }}
                />
            )}

            {/* 📅 Apartado de Eventos */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="card shadow-lg border-0 rounded-4 p-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="fw-bold text-primary mb-0">
                                Eventos del Trámite
                            </h4>
                            <button
                                className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill fw-semibold"
                                onClick={() => {
                                    const hoy = new Date();
                                    const fechaLocal = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
                                    setFechaSeleccionadaEvento(fechaLocal);
                                    setMostrarModalEvento(true);
                                }}
                            >
                                <span style={{ fontSize: '1.2rem' }}>+</span>
                                Crear Evento
                            </button>
                        </div>

                        {cargandoEventos ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status"></div>
                                <p className="mt-2 text-muted">Cargando eventos...</p>
                            </div>
                        ) : eventos.length === 0 ? (
                            <div className="alert alert-info border-0 rounded-3 text-center">
                                <p className="mb-0">
                                    No hay eventos registrados para este trámite
                                </p>
                            </div>
                        ) : (
                            <div className="row g-3">
                                {eventos.map(evento => (
                                    <div key={evento.idEvento} className="col-md-6 col-lg-4">
                                        <div className="card h-100 border rounded-3 p-3 shadow-sm hover-shadow">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <h6 className="fw-bold text-primary mb-0">
                                                    {evento.titulo}
                                                </h6>
                                                {evento.tipoEvento && (
                                                    <span className="badge bg-primary rounded-pill">
                                                        {evento.tipoEvento}
                                                    </span>
                                                )}
                                            </div>

                                            {evento.descripcion && (
                                                <p className="text-muted small mb-2">
                                                    {evento.descripcion}
                                                </p>
                                            )}

                                            <div className="mt-auto">
                                                <div className="d-flex align-items-center gap-2 mb-1">
                                                    <small className="text-muted">📅</small>
                                                    <small className="fw-semibold">
                                                        {formatearFechaEvento(evento.fecha)}
                                                    </small>
                                                </div>

                                                {evento.todoElDia ? (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted">🕐</small>
                                                        <small className="text-success fw-semibold">
                                                            Todo el día
                                                        </small>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted">🕐</small>
                                                        <small>
                                                            {evento.horaInicio} - {evento.horaFin}
                                                        </small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Contenedor con dos columnas */}
            <div className="row g-4">
                {/* 🟦 Datos del trámite */}
                <div className="col-lg-6">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <h4 className="fw-bold text-primary mb-3">
                            Información del Trámite
                        </h4>

                        {editMode ? (
                            <>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Tipo de Trámite</label>
                                    <select
                                        className="form-select rounded-3 shadow-sm"
                                        value={tramiteEdit.idTipoTramite || ""}
                                        onChange={e =>
                                            setTramiteEdit({
                                                ...tramiteEdit,
                                                idTipoTramite: Number(e.target.value),
                                                tipoTramite: tiposTramite.find(t => t.idTipoTramite === Number(e.target.value))
                                            })
                                        }
                                    >
                                        <option value="">Seleccione...</option>
                                        {tiposTramite.map(tipo => (
                                            <option key={tipo.idTipoTramite} value={tipo.idTipoTramite}>
                                                {tipo.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Organismo</label>
                                    <select
                                        className="form-select rounded-3 shadow-sm"
                                        value={tramiteEdit.organismo || ''}
                                        onChange={(e) => setTramiteEdit({ ...tramiteEdit, organismo: e.target.value || null })}
                                    >
                                        <option value="">Sin especificar</option>
                                        <option value="PROVINCIA">Provincia</option>
                                        <option value="ANSES">ANSES</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Patología</label>
                                    <input
                                        type="text"
                                        className="form-control rounded-3 shadow-sm"
                                        placeholder="Ingrese la patología"
                                        value={tramiteEdit.patologia || ""}
                                        onChange={(e) =>
                                            setTramiteEdit({
                                                ...tramiteEdit,
                                                patologia: e.target.value,
                                            })
                                        }
                                    />
                                </div>

                                <div className="d-flex justify-content-center gap-3 mt-4">
                                    <button
                                        className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                        onClick={handleGuardar}
                                    >
                                        Guardar Cambios
                                    </button>
                                    <button
                                        className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                        onClick={handleCancelar}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p>
                                    <strong>ID Trámite:</strong> {tramite.idTramite}
                                </p>
                                <p>
                                    <strong>Tipo de Trámite:</strong>{" "}
                                    {tramite.tipoTramite?.nombre || "N/A"}
                                </p>
                                <p>
                                    <strong>Organismo:</strong>{" "}
                                    {tramite.organismo === 'PROVINCIA' ? 'Provincia'
                                        : tramite.organismo === 'ANSES' ? 'ANSES'
                                        : 'Sin especificar'}
                                </p>
                                <p>
                                    <strong>Patología:</strong>{" "}
                                    {tramite.patologia || "N/A"}
                                </p>
                                <p>
                                    <strong>Estado Actual:</strong>{" "}
                                    {tramite.nombreEstadoActual || "N/A"}
                                </p>
                                <p>
                                    <strong>Fecha Estado Actual:</strong>{" "}
                                    {tramite.fechaEstadoActual
                                        ? new Date(tramite.fechaEstadoActual).toLocaleString()
                                        : "N/A"}
                                </p>


                                {/* ----> [START] BLOQUE CORREGIDO <---- */}
                                {/* Mostrar comentarios de cancelación/reactivación */}
                                {tramite.ultimoComentario && (
                                    <div className="mt-3">
                                        <strong>
                                            {/* Corregido: ID 14 (Cancelado) en lugar de 10 */}
                                            {tramite.idEstadoActual === 14 ? (
                                                <span className="text-warning">
                                                    <CancelIcon fontSize="small" className="me-1" />
                                                    Motivo de Cancelación:
                                                </span>
                                            ) : (
                                                <span className="text-secondary">
                                                    <PersonSearchIcon fontSize="small" className="me-1" />
                                                    Último Comentario de Estado:
                                                </span>
                                            )}
                                        </strong>
                                        {/* Corregido: ID 14 (Cancelado) en lugar de 10 */}
                                        <div className={`border rounded-3 p-3 mt-1 ${
                                            tramite.idEstadoActual === 14
                                                ? 'bg-warning bg-opacity-10 border-warning'
                                                : 'bg-light' // Color neutral para otros comentarios
                                        }`}>
                                            <div style={{ whiteSpace: 'pre-line', fontSize: '0.95rem' }}>
                                                {tramite.ultimoComentario}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* ----> [END] BLOQUE CORREGIDO <---- */}

                                {/* Checklist: Fotocopia DNI / Pacto OK / Carátula */}
                                <ChecklistTramite tramite={tramite} onActualizado={recargarTramite} />
                                <TarjetaCobroTramite
                                    tramite={tramite}
                                    onPactoGenerado={() => { setArchivosVersion((v) => v + 1); recargarTramite(); }}
                                />

                                <div className="mt-4 d-flex justify-content-center gap-3">
                                    {/* --- [MODIFICACIÓN] Ocultar botones si el estado es final --- */}
                                    {!estadosFallidosNombres.includes(tramite.nombreEstadoActual) && tramite.idEstadoActual !== 8 && (
                                        <button
                                            className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                            style={{ fontSize: "1rem" }}
                                            onClick={handleModificar}
                                        >
                                            Modificar Información
                                        </button>
                                    )}

                                    {puedeCancelar() && (
                                        <button
                                            className="btn btn-outline-danger d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                            style={{ fontSize: "1rem" }}
                                            onClick={() => setMostrarDialogoCancelar(true)}
                                        >
                                            <CancelIcon fontSize="small" />
                                            Cancelar Trámite
                                        </button>
                                    )}

                                    {puedeReactivar() && (
                                        <button
                                            className="btn btn-outline-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                            style={{ fontSize: "1rem" }}
                                            onClick={() => setMostrarDialogoReactivar(true)}
                                        >
                                            <PersonSearchIcon fontSize="small" />
                                            Reactivar Trámite
                                        </button>
                                    )}

                                    <button
                                        className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                        style={{ fontSize: "1rem" }}
                                        onClick={handleAbrirGastos}
                                    >
                                        <i className="bi bi-cash-coin"></i>
                                        Ver Gastos
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* 🟩 Datos del cliente */}
                <div className="col-lg-6">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <h4 className="fw-bold mb-3" style={{ color: "#6c757d" }}>
                            Información del Cliente
                        </h4>

                        <div>
                            <p><strong>CUIL:</strong> {cliente.cuil || "N/A"}</p>
                            <p><strong>Apellido:</strong> {cliente.apellido || "N/A"}</p>
                            <p><strong>Nombre:</strong> {cliente.nombre || "N/A"}</p>
                            <p><strong>Oficio / Actividad:</strong> {cliente.oficio || cliente.actividad || "N/A"}</p>
                            <p><strong>Teléfono:</strong> {normalizeTelefonoForStorage(cliente.telefonoPropio) || "N/A"}</p>
                        </div>

                        {cliente.cuil && (
                            <div className="mt-4 d-flex justify-content-center gap-2">
                                <button
                                    className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                    style={{ fontSize: "1rem" }}
                                    onClick={() => verDetalleCliente(cliente.cuil)}
                                >
                                    <PersonSearchIcon fontSize="medium" />
                                    Ver Detalle del Cliente
                                </button>
                            </div>
                        )}

                        {/* Regularidad del Cliente */}
                        {cliente?.regularidad && (
                            <div className="mt-2" style={{ marginTop: '1rem' }}>
                                <div>
                                    <RegularidadAporte regularidad={tramite.cliente.regularidad} />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Expedientes de ANSES: acá, debajo de los datos del trámite y del cliente; arriba solo
                mientras el trámite está en "Seguimiento de Expediente". */}
            {!enSeguimientoDeExpediente(tramite.nombreEstadoActual) && <ExpedientesAnsesTramite idTramite={tramite.idTramite} />}

            {/* 🆕 Apartado de Archivos usando el nuevo componente */}
            <div className="row mt-4">
                <div className="col-12">
                    <CargaArchivos
                        key={archivosVersion}
                        idTramite={idTramite}
                        onArchivosActualizados={(archivos) => {
                            // Callback opcional si necesitas hacer algo cuando se actualicen los archivos
                            console.log("Archivos actualizados:", archivos);
                        }}
                    />
                </div>
            </div>

            {/* Modal para crear evento */}
            <CrearEventoModal
                isOpen={mostrarModalEvento}
                onClose={() => setMostrarModalEvento(false)}
                onSave={handleGuardarEvento}
                selectedDate={fechaSeleccionadaEvento}
                idTramite={idTramite}
            />

            {/* Modal de confirmación de cancelación */}
            {mostrarDialogoCancelar && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0 rounded-4">
                            <div className="modal-header border-0 pb-2">
                                <h5 className="modal-title fw-bold text-warning">
                                    <CancelIcon className="me-2" />
                                    Cancelar Trámite
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setMostrarDialogoCancelar(false);
                                        setMotivoCancelacion('');
                                        setObservacionesCancelacion('');
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body px-4">
                                <div className="alert alert-warning d-flex align-items-center mb-3">
                                    <CancelIcon className="me-2" />
                                    <div>
                                        <strong>¿Está seguro de cancelar este trámite?</strong>
                                        <br />
                                        <small>El trámite pasará al estado "Cancelado". Esta acción se registrará en el historial del trámite.</small>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">
                                        Motivo de cancelación <span className="text-danger">*</span>:
                                    </label>
                                    <select
                                        className="form-select shadow-sm"
                                        value={motivoCancelacion}
                                        onChange={(e) => setMotivoCancelacion(e.target.value)}
                                        required
                                    >
                                        <option value="">Seleccione un motivo...</option>
                                        <option value="Solicitud del cliente">Solicitud del cliente</option>
                                        <option value="Documentación incompleta">Documentación incompleta</option>
                                        <option value="Cambio de circunstancias">Cambio de circunstancias</option>
                                        <option value="Error en la gestión">Error en la gestión</option>
                                        <option value="Desistimiento voluntario">Desistimiento voluntario</option>
                                        <option value="Otros">Otros</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">
                                        Observaciones (opcional):
                                    </label>
                                    <textarea
                                        className="form-control shadow-sm"
                                        rows="3"
                                        placeholder="Detalles adicionales sobre la cancelación..."
                                        value={observacionesCancelacion}
                                        onChange={(e) => setObservacionesCancelacion(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer border-0 pt-0">
                                <button
                                    type="button"
                                    className="btn btn-secondary rounded-pill px-4"
                                    onClick={() => {
                                        setMostrarDialogoCancelar(false);
                                        setMotivoCancelacion('');
                                        setObservacionesCancelacion('');
                                    }}
                                >
                                    Volver
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-warning rounded-pill px-4 fw-semibold"
                                    onClick={handleCancelarTramite}
                                    disabled={!motivoCancelacion.trim()}
                                >
                                    <CancelIcon fontSize="small" className="me-1" />
                                    Cancelar Trámite
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Reactivación */}
            {mostrarDialogoReactivar && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content rounded-4 shadow-lg border-0">
                            <div className="modal-header border-0 pb-0">
                                <h5 className="modal-title fw-bold text-success">
                                    <PersonSearchIcon className="me-2" />
                                    Reactivar Trámite
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setMostrarDialogoReactivar(false);
                                        setObservacionesReactivacion('');
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body py-4">
                                <div className="alert alert-info border-0 rounded-3">
                                    <strong>📋 Información:</strong>
                                    <p className="mb-0 mt-2">
                                        El trámite será reactivado y volverá al estado anterior a la cancelación. <br/>
                                        Esta acción se registrará en el historial del trámite.
                                    </p>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="observacionesReactivacion" className="form-label fw-semibold text-muted">
                                        Observaciones (obligatorio):
                                    </label>
                                    <textarea
                                        id="observacionesReactivacion"
                                        className="form-control rounded-3 border-2"
                                        placeholder="Explique el motivo de la reactivación..."
                                        value={observacionesReactivacion}
                                        onChange={(e) => setObservacionesReactivacion(e.target.value)}
                                        rows="4"
                                        style={{ resize: 'vertical', minHeight: '100px' }}
                                    />
                                    <div className="form-text">
                                        Mínimo 5 caracteres requeridos
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer border-0 pt-0">
                                <button
                                    type="button"
                                    className="btn btn-secondary rounded-pill px-4"
                                    onClick={() => {
                                        setMostrarDialogoReactivar(false);
                                        setObservacionesReactivacion('');
                                    }}
                                >
                                    Volver
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success rounded-pill px-4 fw-semibold"
                                    onClick={handleReactivarTramite}
                                    disabled={!observacionesReactivacion.trim() || observacionesReactivacion.trim().length < 5}
                                >
                                    <PersonSearchIcon fontSize="small" className="me-1" />
                                    Reactivar Trámite
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Acciones irreversibles (cambiar tipo / eliminar definitivamente).
                El propio panel decide si mostrarse segun el rol. */}
            <PanelAccionesAvanzadasTramite
                idTramite={tramite?.idTramite}
                tipoTramite="RTI"
            />

            {/* Modal de Historial de Estados */}
            <HistorialTramite
                isOpen={modalHistorialAbierto}
                onClose={() => setModalHistorialAbierto(false)}
                idTramite={idTramite}
                onEstadoCambiado={recargarTramite}
                ambitoFiltro="RTI"
            />

            {/* Modal de Gastos por Trámite */}
            <ModalGastosPorTramite
                open={modalGastosOpen}
                onClose={handleCerrarGastos}
                idTramite={idTramite}
            />

            <WhatsAppChatModal
                isOpen={whatsAppTarget !== null}
                onClose={() => setWhatsAppTarget(null)}
                clientName={whatsAppTarget?.name || 'Cliente'}
                phone={whatsAppTarget?.phone || ''}
            />

            <CustomModal {...modalState} onHide={hideModal} />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}

export default DetalleTramite;